import React from "react";
import CommonHeader from "../Common Header/CommonHeader";
import SchoolInfo1 from "./SchoolInfo1";

const Disclosure = () => {
  const handlePdfOpen = () => {
    window.open("#", "_blank");
  };

  return (
    <>
      <CommonHeader heading={"MANDATORY PUBLIC DISCLOSURE"} />
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            {/* General Information Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>General Information</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-2">Sr. No</th>
                        <th className="col-xs-4">Information</th>
                        <th className="col-xs-6">Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Name of the School</td>
                        <td>Rama Krishna Public School</td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>Affiliation No</td>
                        <td>5040</td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>School Code</td>
                        <td>29049</td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Complete Address with Pin Code</td>
                        <td>Sec 69, Tulip Road, Badshahpur, Gurugram 122101</td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>Principal Name and Qualification</td>
                        <td>Ms. Kalpana Raghav, MA B.ED and CTET</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>School E-mail ID</td>
                        <td>
                          <a
                            href="mailto:rkps12021@gmail.com"
                            className="text-primary"
                          >
                            rkps12021@gmail.com
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>Contact Details</td>
                        <td>
                          <a href="tel:9643440055" className="text-primary">
                            9643440055
                          </a>
                          ,
                          <a href="tel:9654440055" className="text-primary">
                            9654440055
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Documents and Information Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>Documents and Information</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-2">Sr. No</th>
                        <th className="col-xs-10">Documents</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>
                          <a
                            href="assets/pdf/RECOGNITION CERTIFICATE BY GOVT.pdf"
                            target="_blank"
                          >
                            Copies of Affiliation/Upgradation Letter and Recent
                            Extension of Affiliation
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>
                          <a href="assets/pdf/SOCIETY REG. CERTIFICATE(2).pdf">
                            Copies of societies/Trust/Company
                            Registration/Renewal Certificate
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>
                          <a
                            href="assets/pdf/NOC CERTIFICATE.pdf"
                            target="_blank"
                          >
                            Copy of No Objection Certificate (NOC) Issued, If
                            Applicable, By the date Govt/UT
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>
                          <a
                            href="assets/pdf/RECOGNITION CERTIFICATE BY GOVT.pdf"
                            target="_blank"
                          >
                            Copies of recognition Certificate Under RTE Act,
                            2009, And It's renewal if applicable
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>
                          <a
                            href="assets/pdf/BUILDING SAFETY CERTIFICATE.pdf"
                            target="_blank"
                          >
                            Copy of Valid Building Safety Certificate as per the
                            national Building Code
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>
                          <a
                            href="assets/pdf/FIRE SAFETY CERTIFICATE.pdf"
                            target="_blank"
                          >
                            Copy of Valid Fire Safety Certificate issued by the
                            Competent Authority
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>7</td>
                        <td>
                          <a
                            href="assets/pdf/SELF - CERTIFICATION PROFORMA.pdf"
                            target="_blank"
                          >
                            Copy of the DEO Certificate Submitted by the school
                            for affiliation /Upgradation Extension of
                            affiliation or Self Certification by School
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>8</td>
                        <td>
                          <a
                            href="assets/pdf/WATER AND SANITARY CONDITION CERTIFICATE(1).pdf"
                            target="_blank"
                          >
                            Copies of Valid Water, Health and sanitation
                            Certificates
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Results and Academics Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>Results and Academics</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-2">S.No</th>
                        <th className="col-xs-10">Documents / Information</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>
                          <a href="#" className="text-primary">
                            Fee Structure of the School
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>
                          <a href="#" className="text-primary">
                            Annual Academic Calendar
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>
                          <a href="assets/pdf/SMC.pdf" target="_blank" className="text-primary">
                            List of School Management Committee (SMC)
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>
                          <a href="assets/pdf/GOVERNING COUNCIL, PARENTS TEACHER ASSOCIATION.pdf" target="_blank" className="text-primary">
                            List of Parents Teachers Association (PTA) Members
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Staff Information Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>Staff Information</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-2">S.No</th>
                        <th className="col-xs-6">Information</th>
                        <th className="col-xs-4">Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Principal</td>
                        <td>
                            1
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>PGTS</td>
                        <td>
                            9
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>TGTS</td>
                        <td>
                            5
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>PRTS</td>
                        <td>
                            7
                        </td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>NTTS</td>
                        <td>
                            4
                        </td>
                      </tr>
                      <tr>
                        <td>6.</td>
                        <td>TEACHERS SECTION RATIO</td>
                        <td>1:20</td>
                      </tr>
                      <tr>
                        <td>7.</td>
                        <td>DETAILS OF SPECIAL EDUCATOR AND WELNESS TEACHER</td>
                        <td><strong>Ravinder</strong> <sub>B.Sc in Psychology, D.El.Ed. in special Education</sub></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Infrastructure Details Section */}
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">
                  <strong>Infrastructure Details</strong>
                </h3>
              </div>
              <div className="panel-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr className="info">
                        <th className="col-xs-2">S.No</th>
                        <th className="col-xs-5">Details</th>
                        <th className="col-xs-5">Information</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>Total Campus Area of the School (in Acres)</td>
                        <td>
                            1.0640 Acres
                        </td>
                      </tr>
                      <tr>
                        <td>2</td>
                        <td>No. and Size of the Classrooms (in Sq ft)</td>
                        <td>
                         22 classes (500 sq ft)
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>
                         No. and Size of Laboratories Including Computer Labs (in Sq. ft.)
                        </td>
                        <td>
                            Physics - 600 Sq.Ft.
                          <br />
                            Biology - 600 Sq.Ft.
                          <br />
                            Chemistry - 900 Sq.Ft.
                          <br />
                            Composite - 600 Sq.Ft.
                          <br />
                            Computer - 600 Sq.Ft.
                          <br />
                            Maths - 500 Sq.Ft.
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>Internet Facility (Y/N)</td>
                        <td>
                            Yes
                        </td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>No of Girls Toilets With Partition</td>
                        <td>
                            10
                        </td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>No. of Boys Toilets With Partition</td>
                        <td>
                            10
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* school information component */}
      <SchoolInfo1 />
    </>
  );
};

export default Disclosure;
